var Login = function() {

    var _handleSignInForm = function(e) {
        var validator;

        validator = $("#formLogin").validate({
            ignore: null,
            rules: {
                email: {
                    required: true,
                    email: true
                },
                password: {
                    required: true
                },
            },
            errorElement: "div",
            errorClass : 'fv-help-block text-white',
            wrapper: 'div',
            highlight: function(element) {
                $(element).closest('.form-control').addClass('is-invalid');
            },
            unhighlight: function(element) {
                $(element).closest(".form-control").removeClass("is-invalid");
            },
            errorPlacement: function(error, element) {
                error.addClass('fv-plugins-message-container');
                if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent()); // radio/checkbox?
                } else if (element.hasClass('select2')) {
                    error.insertAfter(element.next('span')); // select2
                } else if (element.attr("type") == "radio") {
                    error.insertAfter(element.closest('div.radio-inline'));
                } else if (element.attr("name") == "content") {
                    error.insertAfter("div#cke_content");
                } else {
                    error.insertAfter(element); // default
                }
            },
        });
    }

    return {
        init: function() {
            _handleSignInForm();
        }
    };
}();

jQuery(function() {
    Login.init();
});